class Accordion {
  constructor(element) {
    this.element = element;
    this.init();
  }

  // getElement() {
  //   return this.element;
  // }

  // getAccordion() {
  //   let element = this.getElement();
  //   return element.querySelectorAll("[data-accordion-title]");
  // }
  validateForm (){
    let name = document.querySelector('#ContactForm-name');
    let email = document.querySelector('#ContactForm-email');
    let message = document.querySelector('#ContactForm-message');
    let regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
    let success = true;

    if(name.value === ''){

    }else {
      name.classList.remove('error');
      success = true;
    }
    
    if(message.value === ''){
      message.classList.add('error');
      success = false;
    }else {
      message.classList.remove('error');
      success = true;
    }
    
    if(email.value  === '') {
      let spanEmail = document.querySelector('#error-email');
      spanEmail.innerHTML = 'Please fill out the email.';
      email.classList.add('error');
      success = false;

    }else if(!regex.test( email.value)){
      let spanEmail = document.querySelector('#error-email');
      spanEmail.innerHTML = 'Please add a valid email';
      email.classList.add('error');
      success = false;

    } else {
      email.classList.remove('error');
      success = true;
    }

    return success;

  }

  addEventHandlers(){
    let send = document.querySelector('#contact-send');
    let self = this;
    send.addEventListener('click', () => {
      let success = self.validateForm();
      if(success){
        document.querySelector('#ContactForm').submit();
      }       
    });
  }

  init() {
    this.addEventHandlers();
  }
}

const ContactInit = {
  init() {
    const $el = document.querySelectorAll("[contact-form]");
    if ($el.length) {
      for (let $e of $el) {
        new Accordion($e);
      }
    }
  },
};


export default ContactInit;